import APIService from '@/services/APIService';

export default {
  /**
   * Создать группу
   * @param {{ short_name: string, full_name: string }} data
   * @returns {Promise<AxiosResponse<T>>}
   */
  createGroups(data) {
    return APIService.post('/groups', data);
  },

  /**
   * Редактировать группу
   * @param {{ short_name: string, full_name: string }} data
   * @returns {Promise<AxiosResponse<T>>}
   */
  updateGroup(id, data) {
    return APIService.put(`/groups/${id}`, data);
  },

  /**
   * Создать группы как в ПФДО
   * @param courseId
   * @returns {Promise<AxiosResponse<any>>}
   */
  createPFDOGroups(courseId) {
    return APIService.get(`/course/${courseId}/create-group-pfdo`);
  },

  /**
   * Удалить группу
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  deleteGroup(id) {
    return APIService.delete(`/groups/${id}`);
  },

  /**
   * Получить данные о группе
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getGroup(id, params) {
    return APIService.get(`/groups/${id}`, params);
  },

  /**
   * Получить список всех групп
   * @returns {Promise<AxiosResponse<T>>}
   */
  getGroupList(params) {
    return APIService.get('/groups', { params });
  },

  /**
   * Добавить пользователя в группу
   * @param id
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  addUserToGroup(id, data) {
    return APIService.post(`/groups/${id}/add-user`, data);
  },

  /**
   * Добавить пользователя в группу из набора
   * @param groupId
   * @param enrollmentId
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  addUserToGroupFromEnrollment(groupId, enrollmentId, data) {
    return APIService.post(`/groups/${groupId}/prior-record/${enrollmentId}/add-users`, data);
  },

  /**
   * Добавить пользователей в группу
   * @param id
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  addUsersToGroup(id, data) {
    return APIService.post(`/groups/${id}/add-users`, data);
  },

  /**
   * Получить список уроков группы
   * @param groupId
   * @returns {Promise<AxiosResponse<T>>}
   */
  getGroupLessons(groupId) {
    return APIService.get(`/groups/${groupId}/lessons`);
  },

  /**
   * Получить список учеников группы
   * @param groupId
   * @returns {Promise<AxiosResponse<any>>}
   */
  getGroupStudents(groupId) {
    return APIService.get(`/groups/${groupId}/users-student`);
  },

  /**
   * Получить список учителей группы
   * @param groupId
   * @returns {Promise<AxiosResponse<any>>}
   */
  getGroupTeachers(groupId) {
    return APIService.get(`/group/${groupId}/teachers`);
  },

  /**
   * Добавить учителей в группу
   * @param groupId
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  addGroupTeachers(groupId, data) {
    return APIService.post(`/group/${groupId}/teachers`, data);
  },

  /**
   * Удалить учителей из группы
   * @param groupId
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  deleteGroupTeachers(groupId, data) {
    return APIService.post(`/group/${groupId}/teachers/delete`, data);
  },

  /**
   * Переместить выбранных учеников в другую группу
   * @param userIds
   * @param groupFrom
   * @param groupTo
   */
  transferUsersToGroup(userIds, groupFrom, groupTo) {
    const data = {
      user_ids: userIds,
      moving_from_group_id: groupFrom,
      moving_to_group_id: groupTo,
    };
    return APIService.post('groups/users/moving', data);
  },

  /**
   * Отчислить пользователей из группы
   * @param groupId
   * @param userIds
   */
  removeUsersFromGroup(groupId, userIds) {
    const data = {
      user_ids: userIds,
    };
    return APIService.post(`group/${groupId}/users/removing`, data);
  },
};
